/**
 * 门店地址图标
 */
const StoreAddressIcon = ({ width = 16, height = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.98958 14.3547C7.98958 14.3547 13.3229 10.8691 13.3229 6.83951C13.3229 3.96609 10.9351 1.63672 7.98958 1.63672C5.04407 1.63672 2.65625 3.96609 2.65625 6.83951C2.65625 10.8691 7.98958 14.3547 7.98958 14.3547Z"
        stroke="#444446"
        strokeWidth="1.33333"
      />
      <path
        d="M8.00033 8.8151C9.01284 8.8151 9.83366 7.99428 9.83366 6.98177C9.83366 5.96926 9.01284 5.14844 8.00033 5.14844C6.98781 5.14844 6.16699 5.96926 6.16699 6.98177C6.16699 7.99428 6.98781 8.8151 8.00033 8.8151Z"
        stroke="#444446"
        strokeWidth="1.33333"
        strokeLinejoin="round"
      />
      W
    </svg>
  )
}

export default StoreAddressIcon
